import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { UXPContext } from "@core/context/Context";
import classNames from "classnames";
import Modal from "../widget/popups/Modal";
import LocalizationForm from "./LocalisationForm";
import IconButton from "@widget/buttons/IconButton";
/**
 * @export
 *
 * This component renders a trigger button that opens a modal for configuring localization messages.
 *
 * @example
 * // Default usage with icon button
 * <LocalizationFormModal code='uxp-core.text.save' />
 *
 * @example
 * // With custom trigger and deferred saving
 * <LocalizationFormModal
 *   code='uxp-core.auth.welcome-to'
 *   useDoneButton={true}
 *   onSave={handleMessagesUpdate}
 *   trigger={<IconButton type="edit" />}
 * />
 */
const LocalizationFormModal = (props) => {
    const context = useContext(UXPContext);
    const [show, setShow] = useState(false);
    const handleOpen = () => {
        if (props.beforeOpen) {
            if (props.beforeOpen()) {
                setShow(true);
            }
        }
        else {
            setShow(true);
        }
    };
    const handleClose = () => {
        setShow(false);
    };
    // Render default trigger if none provided
    const defaultTrigger = _jsx(IconButton, { icon: ['fas', 'language'], variant: 'secondary' });
    const triggerElement = (props === null || props === void 0 ? void 0 : props.trigger) || defaultTrigger;
    return (_jsxs(_Fragment, { children: [!props.hideTrigger && (_jsx("div", { onClick: handleOpen, children: triggerElement })), _jsx(Modal, { show: show, onClose: handleClose, title: context.$L('uxp-core.text.configure-localization-messages'), className: classNames("uxpcore_localisation_form_modal__dialog", props.className), autoSize: true, children: _jsx(LocalizationForm, { code: props.code, useGoogleTranslate: props.useGoogleTranslate, className: props.className, onSave: props.onSave, onCancel: handleClose, submitButtonLabel: props.submitButtonLabel, cancelButtonLabel: props.cancelButtonLabel, hideCancelButton: props.hideCancelButton, customMessages: props.customMessages, allowCodeEdit: props.allowCodeEdit }) })] }));
};
export default LocalizationFormModal;
